import styled from 'styled-components';
import ReactTable from 'react-table';

export const Table = styled(ReactTable)`
  margin: 0;
  width: 100%;
  border: none !important;
`;
